import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/home/Footer';
import './Careers.css';

const Careers = () => {
  const navigate = useNavigate();
  const [workingStyles, setWorkingStyles] = useState([]);
  const [values, setValues] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadData = async () => {
      try {
        const [stylesRes, valuesRes, jobsRes] = await Promise.all([
          fetch('/data/workingStyles.json'),
          fetch('/data/values.json'),
          fetch(`${(process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/$/, '')}/jobs`)
        ]);

        if (!stylesRes.ok || !valuesRes.ok) {
          throw new Error('Failed to load data');
        }

        const styles = await stylesRes.json();
        const vals = await valuesRes.json();
        let jobsList = [];
        if (jobsRes.ok) {
          jobsList = await jobsRes.json();
        } else {
          // Fallback to static JSON if API is unavailable
          const fallback = await fetch('/data/jobs.json');
          if (fallback.ok) jobsList = await fallback.json();
        }

        setWorkingStyles(styles);
        setValues(vals);
        setJobs(Array.isArray(jobsList) ? jobsList : []);
      } catch (err) {
        console.error('Error loading data:', err);
        setError('Failed to load careers data');
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return (
      <div className="careers-page">
        <div className="careers-container">
          <div className="loading">Loading careers information...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="careers-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="careers-container">
          <h1>Join Our Team</h1>
          <p>Help us build the future of the startup ecosystem</p>
        </div>
      </section>

      {/* Working Style Section */}
      <section className="working-style-section">
        <div className="careers-container">
          <h2>How We Work</h2>
          <p className="section-description">
            We believe in creating an environment where talented individuals can thrive and make an impact.
          </p>
          <div className="working-style-cards">
            {workingStyles.map((style) => (
              <div key={style.id} className="style-card">
                <h3>{style.title}</h3>
                <p>{style.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Company Values Section */}
      <section className="values-section">
        <div className="careers-container">
          <h2>Our Values</h2>
          <p className="section-description">
            These core values guide everything we do and define our company culture.
          </p>
          <div className="values-cards">
            {values.map((value) => (
              <div key={value.id} className="value-card">
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Open Positions Section */}
      <section className="open-positions-section">
        <div className="careers-container">
          <h2>Open Positions</h2>
          <p className="section-description">
            We're hiring talented people to join our team. Explore our current openings below.
          </p>

          {error && <div className="error-message">{error}</div>}

          {jobs.length === 0 ? (
            <div className="no-jobs">
              <p>No open positions at the moment. Check back soon!</p>
            </div>
          ) : (
            <div className="jobs-list">
              {jobs.map((job) => (
                <div
                  key={job.id}
                  className="job-list-item"
                  onClick={() => navigate(`/startup-jobs/${job.id}`)}
                >
                  <div className="job-list-header">
                    <h3>{job.title}</h3>
                    <span className="department">{job.department}</span>
                  </div>
                  <div className="job-list-meta">
                    <span className="carrers-job-location">{job.location}</span>
                    <span className="carrers-job-type">{job.type}</span>
                  </div>
                  <p className="job-description">
                    {job.description.substring(0, 150)}...
                  </p>
                  <button className="view-button">View Details →</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Careers;
